import { MembersEndpoint, FakeMembersEndpoint } from '@/api/Members/members';
import { CartEndpoint, FakeCartEndpoint } from '@/api/Cart/cart';
import { MyBookingEndpoint, FakeMyBookingEndpoint } from '@/api/MyBooking/myBooking';
import {
    MyBookingFlightVerificationEndpoint,
    FakeMyBookingFlightVerificationEndpoint,
} from '@/api/MyBookingFlightVerification/myBookingFlightVerification';
import { CheckoutEndpoint, FakeCheckoutEndpoint } from '@/api/Checkout/checkout';
import { PaymentEndpoint, FakePaymentEndpoint } from '@/api/Payment/payment';
import { SeatingEndpoint, FakeSeatingEndpoint } from '@/api/Seating/seating';
import { SembonusEndpoint, FakeSembonusEndpoint } from '@/api/Sembonus/sembonus';
import { ErrorEndpoint, FakeErrorEndpoint } from '@/api/Errors/errors';
import { ItineraryEndpoint, FakeItineraryEndpoint } from '@/api/Itinerary/itinerary';
import {
    MyBookingSessionEndpoint,
    FakeMyBookingSessionEndpoint,
} from '@/api/MyBookingSession/myBookingSession';
import {
    MyBookingCredentialsEndpoint,
    FakeMyBookingCredentialsEndpoint,
} from '@/api/MyBookingCredentials/myBookingCredentials';
import {
    AuthenticateEndpoint,
    FakeAuthenticateEndpoint,
} from '@/api/Authenticate/authenticate';
import { AffiliateEndpoint, FakeAffiliateEndpoint } from '@/api/Affiliate/affiliate';
import { SmartSearchEndpoint, FakeSmartSearchEndpoint } from '@/api/SmartSearch/smartSearch';
import { MyBookingsEndpoint, FakeMyBookingsEndpoint } from './MyBookings/myBookings';
import {
    MyBookingStaticContentEndpoint,
    FakeMyBookingStaticContentEndpoint,
} from './MyBookingStaticContent/myBookingStaticContent';
import { TransferEndpoint, FakeTransferEndpoint } from './Transfer/transfer';
import { isLocalHost, isStenaLine, isWhiteLabel } from '@/helpers/url';
import { isUsingFakeData } from '@/components/shared/DevPanel/DevPanel.helpers';
import { ContentEndpoint, FakeContentEndpoint } from '@/api/Content/content';
import { FakeLeaBankEndPoint, LeaBankEndpoint } from '@/api/LeaBank/leaBank';

export function getBaseUrl(): string {
    if (!(isWhiteLabel() || isStenaLine()) && !isLocalHost()) {
        return '/d/';
    }
    return '/';
}

class Endpoints {
    public constructor(private baseUrl: string) {
        this.authenticate = new AuthenticateEndpoint(this.baseUrl);
        this.members = new MembersEndpoint(this.baseUrl);
        this.cart = new CartEndpoint(this.baseUrl);
        this.myBooking = new MyBookingEndpoint('');
        this.myBookingSession = new MyBookingSessionEndpoint(this.baseUrl);
        this.myBookingContent = new MyBookingStaticContentEndpoint(this.baseUrl);
        this.myBookingCredentials = new MyBookingCredentialsEndpoint(this.baseUrl);
        this.myBookingFlightVerification = new MyBookingFlightVerificationEndpoint(
            this.baseUrl
        );
        this.myBookings = new MyBookingsEndpoint('');
        this.affiliate = new AffiliateEndpoint(this.baseUrl);
        this.checkout = new CheckoutEndpoint(this.baseUrl);
        this.payment = new PaymentEndpoint(this.baseUrl);
        this.sembonus = new SembonusEndpoint(this.baseUrl);
        this.seating = new SeatingEndpoint(this.baseUrl);
        this.itinerary = new ItineraryEndpoint(this.baseUrl);
        this.content = new ContentEndpoint('');
        this.error = new ErrorEndpoint(this.baseUrl);
        this.smartSearch = new SmartSearchEndpoint();
        this.transfer = new TransferEndpoint(this.baseUrl);
        this.leaBank = new LeaBankEndpoint('');
    }

    public authenticate: AuthenticateEndpoint;
    public members: MembersEndpoint;
    public cart: CartEndpoint;
    public myBooking: MyBookingEndpoint;
    public myBookingSession: MyBookingSessionEndpoint;
    public myBookingContent: MyBookingStaticContentEndpoint;
    public myBookingCredentials: MyBookingCredentialsEndpoint;
    public myBookings: MyBookingsEndpoint;
    public myBookingFlightVerification: MyBookingFlightVerificationEndpoint;
    public affiliate: AffiliateEndpoint;
    public checkout: CheckoutEndpoint;
    public payment: PaymentEndpoint;
    public sembonus: SembonusEndpoint;
    public seating: SeatingEndpoint;
    public itinerary: ItineraryEndpoint;
    public content: ContentEndpoint;
    public error: ErrorEndpoint;
    public smartSearch: SmartSearchEndpoint;
    public transfer: TransferEndpoint;
    public leaBank: LeaBankEndpoint;
}

class FakeEndpoints {
    public constructor(private baseUrl: string) {
        this.authenticate = new FakeAuthenticateEndpoint();
        this.members = new FakeMembersEndpoint(this.baseUrl);
        this.cart = new FakeCartEndpoint();
        this.myBooking = new FakeMyBookingEndpoint();
        this.myBookingSession = new FakeMyBookingSessionEndpoint();
        this.myBookingContent = new FakeMyBookingStaticContentEndpoint(this.baseUrl);
        this.myBookingCredentials = new FakeMyBookingCredentialsEndpoint();
        this.myBookings = new FakeMyBookingsEndpoint();
        this.myBookingFlightVerification = new FakeMyBookingFlightVerificationEndpoint();
        this.affiliate = new FakeAffiliateEndpoint();
        this.checkout = new FakeCheckoutEndpoint(this.baseUrl);
        this.payment = new FakePaymentEndpoint(this.baseUrl);
        this.sembonus = new FakeSembonusEndpoint();
        this.seating = new FakeSeatingEndpoint();
        this.itinerary = new FakeItineraryEndpoint();
        this.content = new FakeContentEndpoint(this.baseUrl);
        this.error = new FakeErrorEndpoint();
        this.smartSearch = new FakeSmartSearchEndpoint();
        this.transfer = new FakeTransferEndpoint(this.baseUrl);
        this.leaBank = new FakeLeaBankEndPoint();
    }

    public authenticate: FakeAuthenticateEndpoint;
    public members: FakeMembersEndpoint;
    public cart: FakeCartEndpoint;
    public myBooking: FakeMyBookingEndpoint;
    public myBookingSession: FakeMyBookingSessionEndpoint;
    public myBookingContent: FakeMyBookingStaticContentEndpoint;
    public myBookingCredentials: FakeMyBookingCredentialsEndpoint;
    public myBookings: FakeMyBookingsEndpoint;
    public myBookingFlightVerification: FakeMyBookingFlightVerificationEndpoint;
    public affiliate: FakeAffiliateEndpoint;
    public checkout: FakeCheckoutEndpoint;
    public payment: FakePaymentEndpoint;
    public sembonus: FakeSembonusEndpoint;
    public seating: FakeSeatingEndpoint;
    public itinerary: FakeItineraryEndpoint;
    public content: FakeContentEndpoint;
    public error: FakeErrorEndpoint;
    public smartSearch: FakeSmartSearchEndpoint;
    public transfer: FakeTransferEndpoint;
    public leaBank: FakeLeaBankEndPoint;
}

class EndpointFactory {
    public readonly endpoints = isUsingFakeData()
        ? new FakeEndpoints(getBaseUrl())
        : new Endpoints(getBaseUrl());
}

export const { endpoints } = new EndpointFactory();
